// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__o5Iro","zoom":"Cursor_zoom__rE0yV","pointer":"Cursor_pointer__OqO-9","animated":"Cursor_animated__PeY5Z","cursorClick":"Cursor_cursorClick__rCJ1W"};